export default __webpack_public_path__ + "media/images/building_images/building_location_background-23bac19a2b62158f0b842b9e38fb1332.png";